var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dialog", class: { active: _vm.showDialog } },
    [
      _c("div", { staticClass: "dialog--content", class: _vm.setClass }, [
        _c("p", [_vm._v(_vm._s(_vm.content))]),
        _vm._v(" "),
        _vm.messageType == "delete"
          ? _c("div", { staticClass: "u-extra-small-margin--bottom" }, [
              _c(
                "button",
                {
                  staticClass: "button",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.deleteEvent(true)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("yes")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button gray",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.onCloseDialog()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("no")))]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "close-button",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.onCloseDialog()
              },
            },
          },
          [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }